import { Select } from "@datamole/wds-component-select";
import styled from "styled-components";

import { Chip } from "components/ui/Chip";
import {
    getTipForDevelopmentById,
    TipForDevelopmentCategory,
    tipsForDevelopmentByCategory,
} from "utils/tip-for-development.utils";

const SelectTriggerStyled = styled(Select.Trigger)`
    width: 100%;
    padding: 0.125rem 0.75rem !important;
`;

const SelectContentStyled = styled(Select.Content)`
    z-index: ${({ theme }) => theme.zIndex.dropdown};
`;

type TipForDevelopmentCellProps = {
    canEdit: boolean;
    tipCategory: TipForDevelopmentCategory;
    handleSetTip: (params: { labelTypeId: string; orderNumber: string }) => void;
    tipId: number;
    orderNumber: string;
};

export const TipForDevelopmentCell = ({
    canEdit,
    tipCategory,
    handleSetTip,
    tipId,
    orderNumber,
}: TipForDevelopmentCellProps) => {
    if (!canEdit) {
        const tip = getTipForDevelopmentById(tipId);
        return <Chip variant="outlined">{tip ? tip.name : "Unknown Tip"}</Chip>;
    }

    return (
        <Select
            value={String(tipId)}
            onValueChange={(labelTypeId) => {
                handleSetTip({
                    labelTypeId,
                    orderNumber: orderNumber,
                });
            }}
        >
            <SelectTriggerStyled placeholder={"Select tip..."} />
            <SelectContentStyled>
                {tipsForDevelopmentByCategory[tipCategory].map(({ name, id }) => (
                    <Select.Item key={id} value={id.toString()}>
                        {name}
                    </Select.Item>
                ))}
            </SelectContentStyled>
        </Select>
    );
};
